import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface DatePickerProps {
    selected: Date | null;
    minDate?: Date;
    maxDate?: Date;
    handleChange: (date: Date | null) => void;
    required: boolean;
    label?: string;

}

const EDatePicker: React.FC<DatePickerProps> = ({ selected, minDate, label, required, handleChange, maxDate }) => {
    return (
        <div className='flex flex-col w-full text-[12px]'>
           {
            label && <div>
            <label htmlFor="" className="block font-normal mb-0.5 text-cyan-900 dark:text-gray-200 font-public-sans">{label} {required && <span className='text-red-600'>*</span>}</label>
        </div>
           } 
            <DatePicker
                className="placeholder:text-[11.5px] font-normal placeholder:select-none placeholder:font-light dark:bg-transparent dark:text-gray-300 placeholder:text-gray-300 placeholder:dark:text-gray-500 text-slate-600 text-[12px] font-public-sans w-full focus:outline-none px-2 shadow-sm py-[3.5px] ring-[1px] ring-gray-200 dark:ring-sky-900 rounded-sm focus:ring-1 dark:focus:ring-green-400 focus:ring-green-600"
                calendarClassName='w-full' // Ensure calendar is also full width
                selected={selected}
                isClearable={false} // Enable clear button
                onChange={handleChange}
                required
                maxDate={maxDate}
                minDate={minDate} // Use the minDate prop
                dateFormat="yyyy/MM/dd" // Adjust format as needed
            />
        </div>
    );
}

export default EDatePicker;
